import React, { Component, createRef, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Input, Tree, Col, Spin, Tooltip, Checkbox, Popover } from 'antd';
import { FolderOpenOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons';
import { isEqual, debounce, difference } from 'lodash';
import { callApi } from 'utils';
import PersonInfo from '../components/PersonInfo';
import { SelectContext } from '../context';
import singleSelectMode from '../utils/single-select-mode';

const prefixClx = 'select-modal-new';
const TreeNode = Tree.TreeNode;
const noop = () => { };
class SelectUser extends (PureComponent || Component) {
	static contextType = SelectContext
	constructor (props) {
		super(props);
		//选中的用户列表
		this.targetUsers = [];
		//目标组织树
		this.targetOrg = [];
		//不可选择列表id的对象
		this.disabledObj = this.getDisabledObj(props.disabledSelects);
		// 用户的部门列表
		this.userDepartmentDict = {};
		this.state = Object.assign(
			{
				organizationId: props.organizations && props.organizations.id,
				expandedKeys: [],
				selectedKeys: [],
				searchText: '',
				keywords: '',
				userList: [],
				scrollViewHeight: 0,
			},
			this.getData(props.organizations)
		);
		this.treeBox = createRef();
		this.searchBox = createRef();
	}

	componentWillMount () {
		const { selects = [], origin = '' } = this.props;
		//选中的用户列表
		this.targetUsers = [];
		!origin && this.handleCompatibleData(selects);
	}

	componentDidMount() {
		let scrollViewHeight = 0;
		if (this.treeBox.current && this.searchBox.current) {
			const searchBox = window.getComputedStyle(this.searchBox.current);
			scrollViewHeight = this.treeBox.current.parentElement.clientHeight - parseInt(searchBox.height) - parseInt(searchBox.marginTop) - parseInt(searchBox.marginBottom);
		}
		this.setState({
			scrollViewHeight,
		});
	}

	componentWillReceiveProps (nextProps) {
		const { selects = [] } = nextProps;
		//在resultbox操作时要过滤掉部门
		if (!isEqual(this.props.selects, selects)) {
			this.setState({
				selectedKeys: selects.filter(val => (val.flowUserSelectionType === 'person' || val.sourceTypeA === 'source_user'))
					.reduce((acc, cur) => {
						return acc.concat(this.userDepartmentDict[String(cur.sourceIdA)]?.map(depId => `${depId}-${cur.sourceIdA}`) ?? []);
					}, []),
			});
		}
	}

	// 处理数据兼容
	handleCompatibleData = (selects) => {
		const { idKey, organizations = {} } = this.props;
		const { manageSceneFlag } = this.context;
		const oldSelects = [...selects];
		const toHandleData = [];
		const selectedKeys = [];
		// 选用户兼容，没有部门id时设置主部门id
		selects.forEach((item, idx) => {
			if (item.flowUserSelectionType === 'person' || item.sourceTypeA === 'source_user') {
				if (item.sourceIdB === undefined) {
					toHandleData.push({
						pos: idx,
						id: item.sourceIdA,
					});
				} else {
					selectedKeys.push(`${item.sourceIdB}-${item.sourceIdA}`);
				}
			}
		});
		this.setState({
			selectedKeys,
		});
		if (toHandleData.length && organizations.id) {
			callApi({
				api: '/org_v6/listPrimaryDepartmentByUser',
				data: {
					manageSceneFlag,
					organizationId: organizations.id,
					[`${idKey}s`]: toHandleData.map(it => it.id),
				},
				success: (res = []) => {
					// 新的数据
					const newSelects = [...oldSelects];
					res.forEach((it, idx) => {
						newSelects[toHandleData[idx].pos] = { ...selects[toHandleData[idx].pos], sourceIdB: it.organizationDTO.id, sourceTypeB: 'source_department' };
					});
					// 删除旧数据
					this.props.removeItems(toHandleData.map(it => oldSelects[it.pos]));
					// 添加新数据
					this.props.addItems(toHandleData.map(it => newSelects[it.pos]));
				}
			});
		}
	};

	//封装不可选择列表
	getDisabledObj = (disabledList = []) => {
		const obj = {};
		disabledList.filter(val => val.flowUserSelectionType === 'person').forEach(val => {
			obj[Number(val.sourceIdA)] || (obj[Number(val.sourceIdA)] = true);
		});
		return obj;
	};

	getData = organizations => {
		let treeNodes = [],
			expandedKeys = [];
		if (organizations) {
			const id = 'dep' + String(organizations.id);
			expandedKeys = [id];
		}
		return { expandedKeys };
	};

	/**
	   * 根据选择的d增加或减少用户
	   */
	dealUserList = (param, checked) => {
		const { organizations = [], addItems, removeItems, idKey, selects } = this.props;
		let { organizationId, allData } = param;
		this.targetUsers = [];
		const obj = {};
		const { flatGroup } = this;
		// 整个组是否全选
		const validateSelectedAll = (curNodeList = []) => {
			const allContacts = flatGroup(curNodeList);
			let validateResult = false;
			if (allContacts.length > 0) {
				validateResult = allContacts.every(contactItem => selects.some(selectedNode => selectedNode.sourceIdA === contactItem[idKey]));
			}
			return validateResult;
		};

		//是否为机构
		if (allData.groupType) {
			//机构id先去掉前缀
			organizationId = organizationId.slice(3, organizationId.length + 1);
			this.getTargetOrg([organizations], Number(organizationId));
			this.generateUsers(this.targetOrg);
			checked = !validateSelectedAll([allData]);
		} else {
			this.targetUsers = [allData];
		}
		// console.log('person', allData, checked, this.targetUsers);
		if (checked) {
			addItems(this.transToSource(this.targetUsers.reduce((pre, cur) => {
				if (!obj[`${cur.organizationId}-${cur[idKey] || cur.detailId}`]) {
					obj[`${cur.organizationId}-${cur[idKey] || cur.detailId}`] = true;
					pre.push(cur);
				}
				return pre;
			}, [])));
		} else {
			removeItems(this.transToSource(this.targetUsers.reduce((pre, cur) => {
				if (!obj[`${cur.organizationId}-${cur[idKey] || cur.detailId}`]) {
					obj[`${cur.organizationId}-${cur[idKey] || cur.detailId}`] = true;
					pre.push(cur);
				}
				return pre;
			}, [])));
		}
	};

	//获取点击的节点下的组织树
	getTargetOrg = (list, organizationId) => {
		for (let i = 0; i < list.length; i++) {
			const { children = [] } = list[i];
			if (list[i].id === organizationId) {
				this.targetOrg = [list[i]];
				return;
			}
			if (children.length > 0) {
				this.getTargetOrg(children, organizationId);
			}
		}
	};

	// 展开该节点下属的联系人
	flatGroup = (nodeList = [], curGroup = []) => {
		const { disabledObj, flatGroup } = this;
		let newGroup = curGroup.concat([]);
		for (const nodeItem of nodeList) {
			const { id, selectedFlag, contactInfoDTOS = [], children = [] } = nodeItem;
			const nodeDisabled = disabledObj[id] || selectedFlag === 0;
			if (nodeDisabled) continue;
			const pureInfoList = contactInfoDTOS.filter(infoItem => infoItem.targetId !== 0 && !disabledObj[infoItem.id] && infoItem.selectedFlag !== 0);
			newGroup = newGroup.concat(pureInfoList);
			if (children.length > 0) {
				newGroup = [].concat(flatGroup(children, newGroup));
			}
		}
		return newGroup;
	};

	// 改变某个组的全选
	changeGroupSelectAll = (currentNode, selectedAll) => {
		const { selects, addItems, removeItems, idKey } = this.props;
		const groupList = this.flatGroup([currentNode]);
		if (selectedAll) {
			// 找出已选中的，并删除
			const removeList = groupList.filter(item => {
				return selects.some(node => node.sourceIdA === item[idKey] && node.sourceIdB === item.organizationId);
			});
			removeItems(this.transToSource(removeList));
		} else {
			// 找出还未选中的，并添加
			const addList = groupList.filter(item => {
				return !selects.some(node => node.sourceIdA === item[idKey] && node.sourceIdB === item.organizationId);
			});
			addItems(this.transToSource(addList));
		}
	};

	/**
	   * 数据整合成统一格式
	   */
	transToSource = (data) => {
		const { idKey, needAllData } = this.props;
		const temp = data.map(user => ({
			selectionName: user.name || user.contactName || '',
			flowUserSelectionType: 'person',
			sourceIdA: Number(user[idKey] || user.detailId),
			sourceTypeA: 'source_user',
			sourceDataA: needAllData ? user : undefined,
			sourceIdB: user.organizationId,
			sourceTypeB: 'source_department',
		}));
		return temp;
	};

	/**
	   * 生成部门下所有人(包含子部门)
	   */
	generateUsers = (list = []) => {
		const { untrackStatus, idKey } = this.props;
		const { disabledObj } = this;
		for (let i = 0; i < list.length; i++) {
			const { contactInfoDTOS = [], children = [] } = list[i];
			if (contactInfoDTOS.length > 0) {
				if (untrackStatus === 1) {
					this.targetUsers = this.targetUsers.concat(contactInfoDTOS.filter(item => {
						return item.targetId !== 0 && !disabledObj[item[idKey]];
					}));
				} else {
					this.targetUsers = this.targetUsers.concat(contactInfoDTOS.filter(item => {
						return !disabledObj[item[idKey]];
					}));
				}
			}
			if (children.length > 0) {
				this.generateUsers(children);
			}
		}
	};

	/**
	 * 生成部门组织树状数据结构
	 */
	generateNodes = list => {
		this.userDepartmentDict = {};
		const { disabledObj = {}, flatGroup } = this;
		const { untrackStatus, idKey, disabledTip, selects, isLazyLoadData } = this.props;
		// 整个组是否全选
		const validateSelectedAll = (curNodeList = []) => {
			const allContacts = flatGroup(curNodeList);
			let validateResult = false;
			if (allContacts.length > 0) {
				validateResult = allContacts.every(contactItem => selects.some(selectedNode => selectedNode.sourceIdA === contactItem[idKey]));
			}
			return validateResult;
		};
		const genFunc = (list, parentPath = '') => {
			return list.map(node => {
				let { children = [], name, id, contactInfoDTOS = [], detailId, selectedFlag, targetId, isUser, isLeaf, path = parentPath, level = 1, groupPath, organizationId } = node;
				if (contactInfoDTOS.length > 0) {
					contactInfoDTOS.map(val => {
						// 未激活用户，不能用targetId的做标识，因为都是0
						val.id = val.targetId === 0 && idKey === 'targetId' ? val.detailId : val[idKey];
						val.isUser = true;
					});
					children = children.concat(contactInfoDTOS);
				}
				const nodeDisabled = disabledObj[id] || selectedFlag === 0;
				let disabledText = '';
				if (disabledObj[id] && isUser) {
					disabledText = disabledText || disabledTip;
				}
				if (selectedFlag === 0) {
					disabledText = disabledText || '无权限';
				}
				if (((origin && children.length > 0) || (!origin && children.length >= 0)) && children) {
					const selectedAll = validateSelectedAll([node]);
					const isSingleSelectMode = singleSelectMode({ context: this.context });
					return (
						<TreeNode
							key={`dep${id}`}
							disabled={nodeDisabled}
							allData={node}
							// 通过左侧的按钮控制,不在这里控制了
							selectable={false}
							isLeaf={ isLazyLoadData && !!isLeaf }
							title={(
								<div title={disabledText || null} className={`${prefixClx}-node`}>
									<span className={`${prefixClx}-node-name`}>
										<FolderOpenOutlined className='type-icon' />{name}
									</span>
									{ // 在懒加载模式中，不再启用全选和取消全选
										// 单选模式中, 不再启用全选和取消全选
										isLazyLoadData || isSingleSelectMode || nodeDisabled || children.length < 1
											? null
											: <span className={`${prefixClx}-node-handle select-all`} onClick={() => this.changeGroupSelectAll(node, selectedAll)}>{selectedAll ? '取消全选' : '全选'}</span>
									}
								</div>)}
						>
							{genFunc(children, path)}
						</TreeNode>
					);
				}
				if (untrackStatus === 1 && targetId === 0) {
					disabledText = '用户未激活' || disabledText;
				}
				if (this.userDepartmentDict[String(id)]) {
					this.userDepartmentDict[String(id)].push(organizationId);
				} else {
					this.userDepartmentDict[String(id)] = [organizationId];
				}
				const selected = (() => {
					if (untrackStatus === 1 && targetId === 0) {
						return false;
					}
					return selects.some(selectNode => selectNode.sourceIdA === node[idKey]);
				})();
				// 走到这里，这里可能会有无 下级/人员 数据的部门，或者是人员
				return (
					<TreeNode
						key={isUser ? `${organizationId}-${(targetId === 0 ? 'disabled-' : '') + id}` : `dep${id}`}
						disabled={nodeDisabled || (untrackStatus === 1 && targetId === 0)}
						allData={node}
						isLeaf={ isUser || (isLazyLoadData && !!isLeaf) }
						title={<div title={disabledText || null} className={`${prefixClx}-node`}>
							{
								isUser ? (
									<Popover title={name} mouseEnterDelay={0.5} content={<PersonInfo detail={node} />}>
										<span className={`${prefixClx}-node-name`}>
											<UserOutlined className='type-icon' />
											{name}{(targetId === 0 ? '（未激活）' : '')}
										</span>
									</Popover>
								) : (
									<span className={`${prefixClx}-node-name`}>
										<FolderOpenOutlined className='type-icon' />
										{name}
									</span>
								)
							}
							{isUser ? (
								<span className={`${prefixClx}-node-handle`}>
									<Checkbox disabled={nodeDisabled || (untrackStatus === 1 && targetId === 0)} checked={selected} />
								</span>
							) : null}
						</div>}
					/>
				);
			});
		};
		// 递归生成 react node
		const nodes = genFunc(list);
		const handleNodes = nodes => {
			let anyActive = false;
			for (let index = 0; index < nodes.length; index++) {
				const node = nodes[index];
				if (node.props.children) {
					if (node.props.disabled) {
						continue;
					}
					const childActive = handleNodes(node.props.children);
					const newNode =	React.cloneElement(node, {
						disabled: !childActive
					});
					nodes[index] = newNode;
					anyActive = anyActive || childActive;
				} else {
					if (Array.isArray(node.props.allData.children)) {
						anyActive = true;
					} else if (anyActive) {
						break;
					} else if (!node.props.disabled) {
						anyActive = true;
						break;
					}
				}
			}
			return anyActive;
		};
		// 递归处理 react node，子节点全部禁用时，父节点禁用
		handleNodes(nodes);
		return nodes;
	};

	/**
	 * 生成搜索结果数据结构
	 */
	generateList = () => {
		const { searchList } = this.state;
		const { disabledObj } = this;
		const { untrackStatus, idKey, disabledTip = '', selects } = this.props;
		return searchList.map(node => {
			const { contactName, visibleFlag, targetId, groupPath = '', detailId, organizationId, fullPathDptName, isUser } = node;
			const id = idKey === 'targetId' && targetId === 0 ? detailId : node[idKey];
			const nodeDisabled = disabledObj[id] || visibleFlag === 0 || (untrackStatus === 1 && targetId === 0);
			let disabledText = '';
			if (disabledObj[id]) {
				disabledText = disabledTip;
			}
			if (visibleFlag === 0) {
				disabledText = disabledText || '无权限';
			}
			if (untrackStatus === 1 && targetId === 0) {
				disabledText = '用户未激活' || disabledText;
			}
			const selected = (() => {
				if (untrackStatus === 1 && targetId === 0) {
					return false;
				}
				return selects.some(selectNode => selectNode.sourceIdA === node[idKey]);
			})();
			return (
				<TreeNode
					key={`${organizationId}-${(targetId === 0 ? 'disabled-' : '') + id}`}
					disabled={nodeDisabled}
					allData={node}
					title={<div title={disabledText} className={`${prefixClx}-node`}>
						<Popover title={contactName} mouseEnterDelay={0.5} content={<PersonInfo detail={node} />}>
							<span className={`${prefixClx}-node-name`}>
								<UserOutlined className='type-icon' />
								{contactName}{(targetId === 0 ? '（未激活）' : '')}
							</span>
						</Popover>
						<span className={`${prefixClx}-node-handle`}>
							<Checkbox disabled={nodeDisabled} checked={selected} />
						</span>
					</div>}
				/>
			);
		});
	};

	/**
	 * 获取当前选中树节点的子节点keys
	 */
	getTreeChildKeys = node => {
		const childKeys = [];
		const loop = (children = []) => {
			children.forEach(item => {
				childKeys.push(item.id);
				if (item.children && item.children.length) loop(item.children);
				if (item.contactInfoDTOS && item.contactInfoDTOS.length) loop(item.contactInfoDTOS);
			});
		};
		if (node.children && node.children.length) loop(node.children);
		if (node.contactInfoDTOS && node.contactInfoDTOS.length) loop(node.contactInfoDTOS);
		return childKeys;
	};

	/**
	 * 选中某项
	 * @param {string[]} selectedKeys
	 */
	onSelect = (prevKeys, selectedKeys, { node, selected }) => {
		const deleteKeys = difference(prevKeys, selectedKeys);
		const deleteDict = deleteKeys.reduce((acc, cur) => {
			acc[cur.split('-')[1]] = true;
			return acc;
		}, {});
		selectedKeys = [...new Set(selectedKeys.map(it => it.split('-')[1]))].filter(it => !deleteDict[it]);
		const eventKey = node.key;
		this.setState({
			selectedKeys: selectedKeys.reduce((acc, sourceIdA) => {
				return acc.concat(this.userDepartmentDict[sourceIdA]?.map(depId => `${depId}-${sourceIdA}`) ?? []);
			}, []),
		});
		console.log('persopn', selectedKeys, node);
		this.dealUserList({
			organizationId: eventKey,
			allData: node.allData
		}, selected);
	};

	/**
	 * 点击展开/收缩树节点
	 */
	onExpand = (keys, info) => {
		this.setState({
			expandedKeys: keys
		});
	};

	/**
	 * 根据关键字搜索
	 */
	searchByKeywords = (keywords = '') => {
		const { privilegeFilterFlag = 0, config, hiddenFilterFlag = 0, isSearchFromExist, organizations = [] } = this.props;
		const { manageSceneFlag } = this.context;
		const { organizationId } = this.state;
		keywords = keywords.trim();
		if (keywords) {
			this.setState({ loading: true, showSearchBox: true, searchText: keywords, });
			if (isSearchFromExist) {
				const members = [];
				const loopSearch = (node) => {
					const { children, contactInfoDTOS } = node;
					if (contactInfoDTOS && contactInfoDTOS.length) {
						contactInfoDTOS.forEach(contact => {
							if (contact?.name?.includes(keywords)) {
								members.push({
									...contact,
									contactName: contact.name
								});
							}
						});
					}
					if (children && children.length) {
						children.forEach(child => {
							loopSearch(child);
						});
					}
				};
				loopSearch(organizations);

				this.setState({
					searchList: members,
					loading: false,
				});
			} else {
				callApi({
					api: '/newOrg/findOrgPersonal',
					data: {
						organizationId,
						keywords,
						privilegeFilterFlag,
						appId: window.$$context.appId,
						hiddenFilterFlag,
			  			manageSceneFlag
					},
					success: ({ members = [] }) => {
						this.setState({
							searchList: members,
							loading: false,
						});
					}
				});
			}
		} else {
			this.setState({
				loading: true,
				showSearchBox: true,
				searchList: [],
				searchText: keywords,
			}, () => {
				this.setState({ loading: false });
			});
		}
	};

	//防抖
	searchByKeywordsDebounced = debounce(this.searchByKeywords, 500);

	render () {
		const { loading, searchText, expandedKeys, selectedKeys, searchList = [], showSearchBox, scrollViewHeight } = this.state;
		const { organizations, lazyLoadOrganization } = this.props;
		return (
			<Col span={24} className="tree-box" ref={this.treeBox}>
				<div className='select-box-search' ref={this.searchBox}>
					<Input
						placeholder="请输入姓名、手机号"
						prefix={<SearchOutlined />}
						onChange={e => this.searchByKeywordsDebounced(e.target.value)}
						allowClear
					/>
				</div>
				<div className={'select-scroll-view'}>
					{
						showSearchBox && searchText
							? loading
								? <Spin className='tree-box-center' />
								: searchList.length < 1
									? <div className='tree-box-center'>未找到相关结果</div>
									: <Tree
											multiple
											height={scrollViewHeight}
											selectedKeys={selectedKeys}
											onSelect={this.onSelect.bind(null, selectedKeys)}
											selectable
										>
											{this.generateList()}
										</Tree>
							: loading ? <Spin className='tree-box-center' /> : <Tree
								multiple
								height={scrollViewHeight}
								expandedKeys={expandedKeys}
								selectedKeys={selectedKeys}
								onExpand={this.onExpand}
								onSelect={this.onSelect.bind(null, selectedKeys)}
								selectable
								loadData={lazyLoadOrganization}
							>
								{this.generateNodes([organizations])}
							</Tree>
					}
				</div>
			</Col>
		);
	}
}

SelectUser.propTypes = {
	// 组织架构数据
	organizations: PropTypes.object.isRequired,
	// 选中的列表， 数据结构为 [{selectionName: 显示名称, flowUserSelectionType: 'person', sourceIdA: ID, sourceTypeA: 'source_user', sourceIdB: ID, sourceTypeB: 'source_department'}]
	// selectionName、sourceIdA 必传， flowUserSelectionType、sourceTypeA 都为固定值，根据义务是否有需求来选择传入
	selects: PropTypes.array.isRequired,
	// 选中的用户改变时的回调
	onChange: PropTypes.func.isRequired,
	// 选择类型：checkbox（默认） 多选，radio 单选。
	selectType: PropTypes.string,

	/* 以下是configs额外传进来的参数 */
	// 不可选的用户列表，数据结构为 [{sourceIdA: 用户id}]
	disabledSelects: PropTypes.array,
	// sourceIdA 所代表的key，默认值为 targetId
	idKey: PropTypes.string,
	// 是否需要返回所选人员的全部数据，如果为true，则在selects中将添加一个字段 sourceDataA，默认为false
	needAllData: PropTypes.bool,
	// 未注册用户的状态：1 不可选择（默认），2 可选择
	untrackStatus: PropTypes.number,

	addItems: PropTypes.func.isRequired, // 选中一个条目的回调
	removeItems: PropTypes.func.isRequired, // 选中一个条目的回调
	isLazyLoadData: PropTypes.bool, // 是否使用对数据进行懒加载的功能
	lazyLoadOrganization: PropTypes.func, // 使用懒加载数据的时候，需要在获取子部门时调用的方法
};

SelectUser.defaultProps = {
	disabledSelects: [],
	idKey: 'targetId',
	needAllData: false,
	untrackStatus: 1
};

export default SelectUser;
